export const blockIconsHardwareStart = (
	<span className='material-symbols-outlined'>start</span>
);
